import React, {useEffect} from 'react';
import LeftMenu from "./menu/left-menu";
import ModalReportSelect_Main from "./main/main";
import ErrorBoundary from "../../../../core/error-boundary";
import ModalReportSelect_SearchResults from "./main/search/search-result";
import NewReportForm from "./main/forms/add-form";
import Report from "../../../../core/model2/report/report";
import modalReportSelect_getTemplates, {ReportsSelectorGroup} from "./templates/get-templates";
import ModalReportSelect_ReportPreview from "./main/report-preview";
import stopPropagation from "../../../../core/gd/utils/stop-propagation";
import ModalReportSelect_GroupedReportPreview from "./main/grouped-report-preview";

type Props = {
    params: {
        onSubmit        : callback
    }
}

export default function ModalReportSelect(props: Props) {

    const templateGroups = modalReportSelect_getTemplates()

    const [selectedGroup, setSelectedGroup]     = React.useState<ReportsSelectorGroup>(templateGroups[0])
    const [selectedReport, setSelectedReport]   = React.useState<Report | null>(null)

    // Search
    const [searchValue, setSearchValue]         = React.useState("");
    const [searchResults, setSearchResults]     = React.useState<any[]>([]);

    const onSelectReport = (report: any)=> {
        setSelectedReport(report)
        // setSearchValue("")
        // setSearchResults([])
    }

    const onSelectGroup = (group: ReportsSelectorGroup)=>{
        setSelectedReport(null)
        setSelectedGroup(group)
    }

    const onSearch = (results: any[])=>{
        setSearchResults(results)
    }

    const filterResults = ()=>{

        setSelectedReport(null)

        const reports = templateGroups.filter((group)=>!group.grouped).reduce((acc: any[], group: any)=>{
            return acc.concat(group.items)
        }, [])

        const results = reports.filter((model: Report)=>{
            if( searchValue.length > 0 && (model.name.toLowerCase().includes(searchValue.toLowerCase().trim()))){
                // || model.description.toLowerCase().includes(searchValue.toLowerCase().trim()))){
                return model
            }
        })

        onSearch(_.uniqBy(results, "name"))
    }

    const closeModal = (e: React.SyntheticEvent)=>{
        e.stopPropagation()
        gd.modal.hide()
    }

    useEffect(()=>{
        filterResults()
    }, [searchValue])


    const searchEnabled = searchValue.length > 0;

    return (
        <div className="ui-new-cover" onClick={()=>{}}>
            <div className="ui-new-container" onClick={stopPropagation}>
                <div className="ui5-control-button ui5-icon-close ui5-color-system-black s-26 fs-14 quick-add-close"
                     onClick={closeModal}/>

                <LeftMenu menuItems     = {templateGroups}
                          selectedGroup = {selectedGroup}
                          onSelectGroup = {onSelectGroup}
                          searchValue   = {searchValue}
                          setSearchValue= {setSearchValue}/>

                <ErrorBoundary>

                    <ModalReportSelect_Main selectedGroup  = {selectedGroup}
                                            selectedReport = {selectedReport}
                                            onSubmit       = {props.params.onSubmit}
                                            searchEnabled  = {searchEnabled}
                                            onSelectReport = {onSelectReport}>

                        {searchEnabled && !selectedReport &&
                            <ModalReportSelect_SearchResults searchResults={searchResults}
                                                             searchValue={searchValue}
                                                             onSelectReport={onSelectReport} />
                        }

                        {!searchEnabled && !selectedReport && !selectedGroup.grouped &&  selectedGroup.items.map((model: any, key: number) => {
                            return (<ModalReportSelect_ReportPreview key            = {key}
                                                                     report         = {model}
                                                                     onSelectReport = {onSelectReport}/>)
                        })}

                         {!searchEnabled && !selectedReport && selectedGroup.grouped && selectedGroup.items.map((model: any, key: number) => {
                            return (<ModalReportSelect_GroupedReportPreview key            = {key}
                                                                            group          = {model}
                                                                            onSelectReport = {onSelectReport}/>)
                         })}

                        {selectedReport &&
                            <NewReportForm report   = {selectedReport}
                                           onSubmit = {props.params.onSubmit}/>
                        }

                    </ModalReportSelect_Main>

                </ErrorBoundary>
            </div>
        </div>
    );
}
